// @ts-strict-ignore
import React, { useContext, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { Avatar, Box, Combobox } from '@node-space/ui-components'
import { useWalletQuery } from 'hooks/queries'
import { useGetWalletLegacyId } from 'hooks/queries/Wallets/useGetWalletLegacyId'
import { WalletActionContext } from 'pages/Wallets/context/WalletSheetProvider'
import { formatString, roundNumberWithCommas } from 'utils/utils'
import { FiatDepositDetails } from './FiatDepositDetails'

export const FiatDeposit = () => {
  const { t } = useTranslation()
  const [walletAction] = useContext(WalletActionContext)
  const { meta } = walletAction ?? {}
  const { customerWalletDepositDetails } = meta ?? {}
  const { wallet: customerWallet, customer } = customerWalletDepositDetails ?? {}

  const { data: customerWalletLegacyId, isFetching: isFetchingCustomerWalletLegacyId } =
    useGetWalletLegacyId(customerWallet?.id)

  const enableWalletFetch = useMemo(() => {
    if (customerWallet && customerWalletLegacyId && !isFetchingCustomerWalletLegacyId) {
      return true
    }

    if (walletAction?.sourceWalletId) {
      return true
    }
    return false
  }, [
    isFetchingCustomerWalletLegacyId,
    customerWallet,
    walletAction?.sourceWalletId,
    customerWalletLegacyId,
  ])

  const { data: wallet, isFetching: isFetchingWallet } = useWalletQuery(
    Number(customerWalletLegacyId) || Number(walletAction?.sourceWalletId),
    enableWalletFetch
  )

  const isFetching = useMemo(() => {
    return isFetchingCustomerWalletLegacyId || isFetchingWallet
  }, [isFetchingCustomerWalletLegacyId, isFetchingWallet])

  const walletOptions = useMemo(() => {
    if (!wallet) return []

    return [
      {
        LeftElement: (
          <Avatar name={wallet?.currency?.code?.toLowerCase()} type="currency" size="small" />
        ),
        leftText: wallet?.description,
        rightText: formatString(
          t('balanceWithCurrency'),
          roundNumberWithCommas(wallet?.balance, 2),
          wallet?.currency?.code
        ),
        value: wallet?.id?.toString(),
      },
    ]
  }, [wallet, t])

  return (
    <Box testId="depositForm" paddingX={24} width="full" className="my-6 space-y-4 text-gray-100">
      <Combobox
        label={t('wallet')}
        disabled={true}
        defaultValue={wallet?.id?.toString()}
        id="deposit-wallet"
        items={walletOptions}
        loading={isFetching}
        loadingInline={isFetching}
      />
      <FiatDepositDetails
        wallet={wallet}
        isFetchingWallets={isFetching}
        customer={customer}
        customerWallet={customerWallet}
      />
    </Box>
  )
}
